import { render } from "./Hero.vue?vue&type=template&id=b0d40e18"
import script from "./Hero.vue?vue&type=script&setup=true&lang=js"
export * from "./Hero.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "C:\\laragon\\www\\agrifutura\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/frontend/components/Hero.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b0d40e18"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b0d40e18', __exports__)) {
    console.log('reload')
    api.reload('b0d40e18', __exports__)
  }
  
  module.hot.accept("./Hero.vue?vue&type=template&id=b0d40e18", () => {
    console.log('re-render')
    api.rerender('b0d40e18', render)
  })

}


export default __exports__